// extracted by mini-css-extract-plugin
export default {"container":"LeadsPage_container_IcFRM","content":"LeadsPage_content_thiO0"};